/**
 * Where an opportunity's timeline marks its lead's qualification (D-226): above the first item of
 * the lead's story. Times are kept to the second, and a lead qualified at once has its note, its
 * history and the qualification in one second — so the story is told by where an item comes
 * from, its time only where it says nothing (an item older than the qualification). -1: nowhere.
 */
export function qualifiedIndex(items, lead) {
  if (!lead?.qualified_at) return -1
  return items.findIndex((item) => (item.origin?.entity === 'lead' && (!lead.uuid || item.origin.uuid === lead.uuid)) || String(item.at) < lead.qualified_at)
}
